import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererActions from "@/components/upload-file/cell-renderer/CellRendererActions.vue";

export const uploadFileListMixin = {
	name: "UploadFile",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					showPopup: false,
					rowSelection: "multiple",
					activeCheckbox: false,
					activeHeaderCheckboxSelection: false,
					activeLink: true,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showSearch: true,
					showActions: true,
				};
			},
		},
		status_id: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererActions,
	},
	data() {
		return {
			searchQuery: [],
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Id",
			gridApi: null,
			gridOptions: {},
			loadingOverlayComponent: null,
			loadingOverlayComponentParams: null,
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
				flex: 1,
			},
			components: {
				CellRendererActions,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getUploadFile(page);
		},
		quantityElementPage() {
			this.getUploadFile(1);
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		this.getUploadFile(1);
	},
	beforeDestroy() {
		this.removeNotify();
	},
	computed: {
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "Id",
					field: "id",
					width: 270,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
				},
				{
					headerName: this.$t("UploadFiles.UploadType"),
					field: "category",
					filter: filterHead,
					width: 350,
				},
				{
					headerName: this.$t("ManualData.AddedOn"),
					field: "added_on",
					filter: filterHead,
					width: 300,
				},
				{
					headerName: this.$t("ResourceModule.Table.Status"),
					field: "process_state",
					filter: filterHead,
					width: 800,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		usersData() {
			return this.$store.state.uploadFile.uploadedFiles;
		},
	},
	methods: {
		getUploadFile(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				id: [],
				category_id: null,
				process_state: "FINALIZED",
				order_by: "added_on",
				sort: "DESC",
			};
			this.$store
				.dispatch("uploadFile/getUploadFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		search() {
			const searchQueryList = this.searchQuery.map(({value}) => {
				if (this.searchField === "Id") return parseInt(value);
				return value;
			});
			const dataPage = {
				id: this.searchField === "Id" ? searchQueryList : [],
				process_state: this.searchField === "Status" ? searchQueryList : [],
				order_by: "added_on",
				sort: "ASC",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("uploadFile/getUploadFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refresh() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.getUploadFile(1);
			this.removeNotify();
		},
		setSearchField(val) {
			this.searchField = val;
		},
		addNewData() {
			this.$router.push({name: "app-upload-files"});
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		deleteRecordById(id) {
			this.$store
				.dispatch("uploadFile/removeUploadFile", id)
				.then((res) => {
					this.$store.commit("uploadFile/REMOVE_ID_UPLOAD_FILES", id);
					return res;
				})
				.catch((err) => {
					return err;
				});
		},
		removeNotify() {
			if (this.$store.state.uploadFile.uploadedFilesIds.length > 0) {
				for (let id of this.$store.state.uploadFile.uploadedFilesIds) {
					this.deleteRecordById(id);
				}
				let notifyActive = document.querySelectorAll(".vs-notifications");
				for (const notify of notifyActive) {
					notify.classList.remove("vs-notifications");
				}
			}
		},
	},
};
